import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import { isNative } from '@/lib/platform';

/**
 * Syncs the native status bar style with the current theme.
 * Only runs on native iOS/Android apps.
 */
export function useStatusBarSync() {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    if (!isNative()) return;

    const syncStatusBar = async () => {
      try {
        const { StatusBar, Style } = await import('@capacitor/status-bar');
        
        if (resolvedTheme === 'dark') {
          await StatusBar.setStyle({ style: Style.Dark });
        } else {
          await StatusBar.setStyle({ style: Style.Light });
        }
      } catch (error) {
        // StatusBar plugin not available or failed
        console.debug('StatusBar sync skipped:', error);
      }
    };

    syncStatusBar();
  }, [resolvedTheme]);
}
